"use client";

import styled, { css } from "styled-components";
import { sans as zoram, fontSize14, lineHeightTight, fontWeightBold } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
export const internalUseOnlyPriority5 = css(["margin:0;font-family:", ";font-weight:", ";font-size:", ";line-height:", ";"], zoram, fontWeightBold, fontSize14, lineHeightTight);
const H5Styled = styled.h5.withConfig({
  componentId: "sc-1k9r0br-0"
})(["", ";"], internalUseOnlyPriority5);

/**
 * The fifth level heading style. You can override the semantics by passing a different `renderAs` prop to still look like an `h5` but be an `h4` (or other heading) if needed.
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - The content inside the heading
 * @param {React.ElementType} [props.renderAs] - The HTML tag string (e.g., `"div"`) or React component to render
 * @returns {React.ReactNode} The H5 component
 */
const H5 = ({
  children,
  renderAs,
  ...props
}) => /*#__PURE__*/_jsx(H5Styled, {
  as: renderAs,
  ...props,
  children: children
});
H5.displayName = "H5";
export default H5;